import React from "react";

const CableIcon = ({ width, height, color }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="1"
        width="28"
        height="28"
        rx="3"
        fill="#F1F7FA"
        stroke="#064A72"
        strokeWidth="2"
      />
      <path
        d="M21 9.00019H17.41L19.71 6.71019C19.8032 6.61695 19.8772 6.50626 19.9277 6.38443C19.9781 6.26261 20.0041 6.13204 20.0041 6.00019C20.0041 5.86833 19.9781 5.73776 19.9277 5.61594C19.8772 5.49411 19.8032 5.38342 19.71 5.29019C19.6168 5.19695 19.5061 5.12299 19.3842 5.07253C19.2624 5.02207 19.1319 4.99609 19 4.99609C18.7337 4.99609 18.4783 5.10188 18.29 5.29019L15 8.54019L13.83 6.54019C13.7643 6.42594 13.6768 6.32574 13.5724 6.24531C13.468 6.16489 13.3488 6.10581 13.2216 6.07145C13.0944 6.03709 12.9617 6.02813 12.831 6.04507C12.7003 6.06201 12.5743 6.10452 12.46 6.17019C12.3457 6.23585 12.2456 6.32337 12.1651 6.42775C12.0847 6.53214 12.0256 6.65134 11.9913 6.77856C11.9569 6.90577 11.9479 7.03851 11.9649 7.16919C11.9818 7.29987 12.0243 7.42594 12.09 7.54019L13 9.00019H9C8.20435 9.00019 7.44129 9.31626 6.87868 9.87887C6.31607 10.4415 6 11.2045 6 12.0002V20.0002C6 20.7958 6.31607 21.5589 6.87868 22.1215C7.44129 22.6841 8.20435 23.0002 9 23.0002V24.0002C9 24.2654 9.10536 24.5198 9.29289 24.7073C9.48043 24.8948 9.73478 25.0002 10 25.0002C10.2652 25.0002 10.5196 24.8948 10.7071 24.7073C10.8946 24.5198 11 24.2654 11 24.0002V23.0002H19V24.0002C19 24.2654 19.1054 24.5198 19.2929 24.7073C19.4804 24.8948 19.7348 25.0002 20 25.0002C20.2652 25.0002 20.5196 24.8948 20.7071 24.7073C20.8946 24.5198 21 24.2654 21 24.0002V23.0002C21.7956 23.0002 22.5587 22.6841 23.1213 22.1215C23.6839 21.5589 24 20.7958 24 20.0002V12.0002C24 11.2045 23.6839 10.4415 23.1213 9.87887C22.5587 9.31626 21.7956 9.00019 21 9.00019ZM22 20.0002C22 20.2654 21.8946 20.5198 21.7071 20.7073C21.5196 20.8948 21.2652 21.0002 21 21.0002H9C8.73478 21.0002 8.48043 20.8948 8.29289 20.7073C8.10536 20.5198 8 20.2654 8 20.0002V12.0002C8 11.735 8.10536 11.4806 8.29289 11.2931C8.48043 11.1055 8.73478 11.0002 9 11.0002H21C21.2652 11.0002 21.5196 11.1055 21.7071 11.2931C21.8946 11.4806 22 11.735 22 12.0002V20.0002Z"
        fill="black"
      />
    </svg>
  );
};

export default CableIcon;
